module.exports = __webpack_public_path__ + "images/emoji/scorpius.ea22fba1c4ed17fe231c.png";